import { Component, OnInit, ViewChild } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { MatTableDataSource } from "@angular/material/table";
import { Router } from "@angular/router";
import { GeneralService } from "../services/general.service";
import { HttpClient } from "@angular/common/http";
import { RechercheComponent } from "../recherche/recherche.component";
@Component({
  selector: "app-liste-articles",
  templateUrl: "./liste-articles.component.html",
  styleUrls: ["./liste-articles.component.scss"],
})
export class ListeArticlesComponent implements OnInit {
  constructor(
    public dialog: MatDialog,
    private http: HttpClient,
    private router: Router,
    private generalService: GeneralService
  ) {}
  tttt;
  exist = false;
  displayedColumns = ["Art_Code", "Art_Des", "Art_DelaiProd", "Art_PV"];
  dataSource = new MatTableDataSource([
    {
      Art_Code: "08AR0001_X11",
      Art_Des: "art 1",
      Art_DelaiProd: 1,
      Art_PV: 100,
      Art_PV1: null,
      Art_Stock: true,
      Art_Des1: "desc desc desc",
      categorie_Code: 1,
      Art_NbrImages: 1,
    },
    {
      Art_Code: "08AR0001_X4",
      Art_Des: "art 2",
      Art_DelaiProd: 1,
      Art_PV: 50,
      Art_PV1: null,
      Art_Stock: false,
      Art_Des1: "desc desc desc",
      categorie_Code: 1,
      Art_NbrImages: 1,
    },
    {
      Art_Code: "01",
      Art_Des: "art 3",
      Art_DelaiProd: 1,
      Art_PV: 50,
      Art_PV1: null,
      Art_Stock: false,
      Art_Des1: "desc desc desc",
      categorie_Code: 1,
      Art_NbrImages: 1,
    },
    {
      Art_Code: "02",
      Art_Des: "art 4",
      Art_DelaiProd: 1,
      Art_PV: 50,
      Art_PV1: null,
      Art_Stock: false,
      Art_Des1: "desc desc desc",
      categorie_Code: 1,
      Art_NbrImages: 1,
    },
    {
      Art_Code: "03",
      Art_Des: "art 5",
      Art_DelaiProd: 1,
      Art_PV: 50,
      Art_PV1: null,
      Art_Stock: false,
      Art_Des1: "desc desc desc",
      categorie_Code: 1,
      Art_NbrImages: 1,
    },
  ]);
  row;
  disabledBtnSupprimer: boolean = false;
  @ViewChild(RechercheComponent) rechercheComponent;
  ngOnInit() {
    if (this.generalService.userConnecter == "") {
      this.router.navigate([""]);
    } else this.init();
  }
  afficher() {}
  selectRow(event, row) {
    var els = document.getElementsByClassName("mat-row");
    Array.prototype.forEach.call(els, function (el) {
      el.style = "";
    });
    event.currentTarget.style = "background-color: #a0bdf3;";
    this.row = row;
  }
  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }
  modifier() {
    if (this.rechercheComponent.parentVal != undefined) {
      this.router.navigate([
        "admin/article",
        this.rechercheComponent.parentVal.Art_Code,
        "2",
      ]);
    } else
      this.generalService.dialogSuccess(
        "Veillez sélectionner une ligne",
        false
      );
  }
  supprimer() {
    if (this.rechercheComponent.parentVal != undefined) {
      var deleteFn = this.generalService.supprimer(
        this.rechercheComponent.parentVal.Art_Code,
        "ecart"
      );
      if (deleteFn != null) {
        this.deleteCat(this.rechercheComponent.parentVal.Art_Code);
        this.exist = false;
        this.disabledBtnSupprimer = true;
        deleteFn.subscribe(
          (data) => {
            this.generalService.dialogSuccess("Elément supprimer", true);
            this.exist = true;
            this.disabledBtnSupprimer = false;
          },
          (error) => {
            this.generalService.dialogSuccess("Elément non supprimé", false);
            this.exist = true;
            this.disabledBtnSupprimer = false;
          }
        );
      }
    }
  }
  deleteCat(codeArt) {
    this.generalService
      .rechercheTable(this.generalService.urlListCat + codeArt)
      .subscribe((res) => {
        res.forEach((element) => {
          this.generalService
            .supprimerSanMsgConfirm(element?.id, 'ecArtCatArticle')
            .subscribe((res) => {});
        });
      });
  }
  init() {
    this.exist = true;
  }
}
